//General
import React, { useState } from 'react';
//Styles
import { Modal, Tab, Tabs } from 'react-bootstrap';
import { TextField, MenuItem } from '@mui/material';
import { Formik, Form, Field } from 'formik';
//Context & Validations
import { useWarehouse } from '../../data/warehouse/WarehouseContext';
import { useValidations } from '../../data/ValidationContext';
//Components
import ShelfPage from '../../page/ShelfPage';
import ShelfAddModal from '../shelves/ShelfAddModal';
import ShelfUpdateModal from '../shelves/ShelfUpdateModal';

function WarehouseUpdateModal({ show, handleClose, warehouse }) {
  const { updateWarehouse, deleteShelf } = useWarehouse();
  const { vs_warehouse } = useValidations();

  const [selectedShelf, setSelectedShelf] = useState(null);
  const [showShelfAddModal, setShowShelfAddModal] = useState(false);
  const [showShelfUpdateModal, setShowShelfUpdateModal] = useState(false);

  if (!warehouse) return null;

  const initialValues = {
    name: warehouse.name || '',
    location: warehouse.location || '',
    status: warehouse.status || 'Aktif'
  };

  //HTML

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Depo Güncelle</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Tabs defaultActiveKey="info" id="warehouse-tabs">
          {/* Depo Bilgileri */}
          <Tab eventKey="info" title="Depo Bilgileri">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={vs_warehouse}
              onSubmit={(values) => {
                updateWarehouse(warehouse.id, values);
                handleClose();
              }}
            >
              {({ touched, errors, handleChange, values }) => (
                <Form className="d-flex flex-column gap-3 mt-3">
                  <Field
                    as={TextField}
                    name="name"
                    label="Depo Adı"
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={touched.name && !!errors.name}
                    helperText={touched.name && errors.name}
                  />
                  <Field
                    as={TextField}
                    name="location"
                    label="Lokasyon"
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={touched.location && !!errors.location}
                    helperText={touched.location && errors.location}
                  />
                  <TextField
                    select
                    name="status"
                    label="Durum"
                    value={values.status}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    error={touched.status && !!errors.status}
                    helperText={touched.status && errors.status}
                  >
                    {["Aktif", "Pasif"].map((status) => (
                      <MenuItem key={status} value={status}>
                        {status}
                      </MenuItem>
                    ))}
                  </TextField>

                  <div className="d-flex justify-end gap-2 mt-3">
                    <button type="submit" className="btn btn-primary">
                      Güncelle
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                      İptal
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </Tab>

          {/* Raflar */}
          <Tab eventKey="shelves" title="Raflar">
            <div className="mt-3">
              <ShelfPage
                warehouse={warehouse}
                onAdd={() => setShowShelfAddModal(true)}
                onEdit={(shelf) => {
                  setSelectedShelf(shelf);
                  setShowShelfUpdateModal(true);
                }}
                onDelete={(shelfId) => deleteShelf(warehouse.id, shelfId)}
              />

              <ShelfAddModal
                isOpen={showShelfAddModal}
                onClose={() => setShowShelfAddModal(false)}
                warehouseId={warehouse.id}
              />

              <ShelfUpdateModal
                isOpen={showShelfUpdateModal}
                onClose={() => setShowShelfUpdateModal(false)}
                warehouseId={warehouse.id}
                shelf={selectedShelf}
              />
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
}

export default WarehouseUpdateModal;
